const elFormKey = Symbol("elForm");
const elFormItemKey = Symbol("elFormItem");

export { elFormItemKey, elFormKey };
//# sourceMappingURL=form.mjs.map
